import PropTypes from "prop-types"
import intl from 'react-intl-universal'
import { withStyles, makeStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import moment from "moment"
import { formatNumber } from "utils/format"
import { useOrdersContext } from "features/orders/context"
import { SelectBox } from "components/uikit-adapter"

const StyledTableCell = withStyles(() => ({
  head: {
    borderBottom: 'none',
    backgroundColor: 'var(--color-action-default)',
    fontWeight: 'var(--font-weight-semibold)',
    fontSize: 14,
    color: 'white',
    borderRight: '1px solid var(--color-contrast-white)',
    lineHeight: '14px',
    zIndex: 1,
  },
  body: {
    fontSize: 13,
    color: '#313131',
    fontWeight: 'var(--font-weight-regular)',
    borderRight: '1px solid #EDEDED',
    lineHeight: '14px',
    padding: '10px',
    wordBreak: 'break-word',
    textAlign: 'justify'
  },
  root: {
    fontFamily: 'var(--font-family-base)',
    padding: '8px',
    position: 'relative !important',
    '&.justification-cell': {
      overflow: 'visible !important',
    }
  }
}))(TableCell)

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    padding: '8px'
  },
}))(TableRow)

const useStyles = makeStyles({
  root: {
    width: '100%',
    boxShadow: 'none',
    height: "calc(100% - 300px)",
    overflowY: "auto",
  },
  container: {
    overflowY: "auto",
  },
  head: {
    fontWeight: 'var(--font-weight-semibold)',
    color: '#A2A2A2'
  },
  bold: {
    fontWeight: 'bold',
    textAlign: 'center'
  },
  justificationColumn: {
    minWidth: 280, 
    width: '20%',
    position: 'relative !important',
    overflow: 'visible !important'
  }
})

export const OrdersCancelDataTable = ({ data, handleChangeJustificationToARow }) => {
  const classes = useStyles();
  const { cancellationJustifications } = useOrdersContext();  

  return (
    <Paper className={classes.root}>
      <TableContainer className={classes.container}>
        <Table stickyHeader>
          <TableHead className={classes.head}>
            <TableRow>
              <StyledTableCell>{intl.get('commons.orderCode')}</StyledTableCell>
              <StyledTableCell>{intl.get('commons.source')}</StyledTableCell>
              <StyledTableCell>{intl.get('commons.destiny')}</StyledTableCell>
              <StyledTableCell>{intl.get('commons.material')}</StyledTableCell>
              <StyledTableCell>{intl.get('commons.collectDate')}</StyledTableCell>
              <StyledTableCell>{intl.get('commons.deliveryDate')}</StyledTableCell>
              <StyledTableCell>{intl.get('commons.quantity')}</StyledTableCell>
              <StyledTableCell>{intl.get('commons.justification')}</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row) => (
              <StyledTableRow key={row.Id}>
                <StyledTableCell>{row.Id}</StyledTableCell>
                <StyledTableCell>{row.SupplierName}</StyledTableCell>
                <StyledTableCell>{`${row.BusinessUnitPlant} - ${row.BusinessUnitName}`}</StyledTableCell>
                <StyledTableCell>{row.MaterialName}</StyledTableCell>
                <StyledTableCell>{moment(row.OrderCollectDate).format('L')}</StyledTableCell>
                <StyledTableCell>{moment(row.OrderDeliveryDate).format('L')}</StyledTableCell>
                <StyledTableCell>{`${formatNumber(row.OrderQuantity)} ${row.MaterialUnitOfMeasure}`}</StyledTableCell>
                <StyledTableCell className={`${classes.justificationColumn} justification-cell`}>
                  <SelectBox 
                    name='justifications'
                    width={'100%'}
                    labelKey='Value'
                    valueKey='Key'
                    options={cancellationJustifications}
                    value={row.TypeJustificationManualSuggestion}
                    onChange={(value) => handleChangeJustificationToARow(row, value)}
                    searchable
                    openOnFocus
                    menuListStyle={{
                      zIndex: 9999,
                      position: 'relative'
                    }}
                    styles={{
                      menu: (provided) => ({
                        ...provided,
                        zIndex: 9999,
                        position: 'absolute'
                      }),
                      menuPortal: (provided) => ({
                        ...provided,
                        zIndex: 9999
                      })
                    }}
                    menuPortalTarget={document.body}
                  />
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  )
}

OrdersCancelDataTable.propTypes = {
  data: PropTypes.shape({
    map: PropTypes.func
  }).isRequired,
  handleChangeJustificationToARow: PropTypes.func.isRequired
}
